import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MassNotificationTemplate,
  MessageSettings,
  TemplateViewControlType
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import { AssetsElementItem, AssetsElementSettings } from './assets-control-model';
import produce from 'immer';
import { Dataset } from '@app/modules/core/store/models';

@Component({
    selector: 'topo-template-assets-element',
    templateUrl: './assets-control.component.html',
    styleUrls: ['./assets-control.component.scss'],
    standalone: false
})
export class TemplateDesignAssetsElement implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    if (!this.editMode && !!value) {
      this.render();
    }
  }
  _culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Input() editable: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();
  @Output() hideControl = new EventEmitter();
  @Output() showControl = new EventEmitter();

  editMode: boolean;
  assetsHeaderText: string;
  assetsDetails: string;
  hideFromPreview: boolean;
  private dataset: Dataset;
  private document: Document;
  private mapUId: string;

  constructor(private translateService: TranslateService, private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
  }
  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;

    if (this.editable === false) {
      this.hideFromPreview = !!!this.document || !!!this.mapUId;
      if (this.hideFromPreview == true) {
        this.hideControl.emit();
      } else {
        this.showControl.emit();
      }
    }

    this.assetsHeaderText = this.templateDesignerService.getStaticTranslateText('CLOSEST-ASSETS', this._culture);
    if (!!!this.assetsDetails) {
      this.assetsDetails = "<div style='font-size: 14px; font-weight: 600; margin: 4px;'>...</div>";
    }
  }
  edit(): void {}

  setRuntimeData(value: any) {
    if (!this.editMode) {
      if (!!value) {
        const settings = value as AssetsElementSettings;
        this.assetsDetails = `<div style="margin: 8px 0px;"></div>`;
        settings?.items.forEach(item => {
          this.assetsDetails += `<div style="font-size: 14px; margin-top: 4px"><span style="font-weight: 600">${item.name}</span> <span style="font-weight: 400">(${item.count})</span></div>`;
        });
        this.render();

        const control = produce(this.control, draftState => {
          if (!!!draftState.settings) {
            draftState.settings = {
              items: []
            } as AssetsElementSettings;
          }
          draftState.settings.items = settings?.items;
        });

        this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
      } else {
        this.hideFromPreview = true;
      }
    }
  }

  setDocumentContext(dataset: Dataset, document: Document, mapUId: string) {
    this.dataset = dataset;
    this.document = document;
    this.mapUId = mapUId;

    if (!this.editMode) {
      this.render();
    }
  }
}
